// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getCustomerListApi } from "../../Service/Api/CustomerListApi"

import { getCustomer, getErrors } from "../Reducer/CustomerListReducer"




// Watchers
function* customerListSaga() {
	yield takeEvery("customerList/getCustomerList", fetchCustomer)
}

// Sagas
function* fetchCustomer(action) {

	try {
		const customerList = yield call(getCustomerListApi, action.payload)

		if (customerList.request.status === 200) {
            // console.log(storeList);
			yield put(getCustomer(customerList))
		} else {
			yield put(getErrors(true))
		}
	} catch (error) {
        // console.log(error);
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(customerListSaga)])
}
